(function () {
  const LIST_SELECTORS = ['.ga-products-table', '.g_related_product', '.globo-related-products'];
  const modal = document.getElementById('grl-modal');

  if (!modal) return;
  const body = modal.querySelector('#grlBody');
  const overlayCloseEls = modal.querySelectorAll('[data-grl-close]');

  function openModal() {
    modal.classList.add('is-open');
    modal.classList.remove('hidden');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.classList.remove('is-open');
    setTimeout(() => {
      modal.classList.add('hidden');
      body.innerHTML = '';
      document.documentElement.style.overflow = '';
    }, 280);
  }
  overlayCloseEls.forEach(el => el.addEventListener('click', closeModal));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeModal(); });

  // Helpers
  const listMatches = (el) => LIST_SELECTORS.some(sel => el.closest(sel));
  const extractHandle = (url) => {
    try { return (new URL(url, location.origin).pathname.match(/\/products\/([^/?#]+)/) || [])[1]; }
    catch { return null; }
  };

  // Collect up to 3 product URLs from the Globo list
  function collectProductsFromList(root) {
    const anchors = root.querySelectorAll('li.ga-product a[href*="/products/"]');
    const items = [];
    anchors.forEach(a => {
      const h = extractHandle(a.href);
      if (h && !items.find(x => x.handle === h)) items.push({ handle: h, url: a.href });
    });
    return items.slice(0, 3);
  }

  // Intercept click on any Globo item
  document.addEventListener('click', function (e) {
    const item = e.target.closest('li.ga-product');
    if (!item) return;
    if (!listMatches(item)) return;
    if (e.target.matches('input,select,button,label')) return; // ignore form controls
    e.preventDefault();

    const listRoot = item.closest(LIST_SELECTORS.join(','));
    const prods = collectProductsFromList(listRoot);
    if (prods.length === 0) return;

    openModal();
    body.innerHTML = '<div class="grl__loading">Loading…</div>';

    Promise.all(
      prods.map(p =>
        fetch(p.url + (p.url.includes('?') ? '&' : '?') + 'view=quick', { credentials: 'same-origin' })
          .then(r => r.text()).catch(() => '')
      )
    ).then(htmls => {
      body.innerHTML = htmls.join('');
    }).catch(() => {
      body.innerHTML = '<p>Sorry, something went wrong.</p>';
    });
  });

  // If Globo renders late, re-bind via MutationObserver is not needed because we delegate on document.
})();
